import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(3, 7),
    [theme.breakpoints.up('md')]: {
      '&:first-child': {
        paddingTop: theme.spacing(3),
      },
    },
  },
}))

export default useStyles
